import { api } from "@/lib/api";

declare global { interface Window { dataLayer?: unknown[]; gtag?: (...a: unknown[]) => void } }

const KNOWN: [string, string][] = [["pinterest", "pinterest"], ["pin.it", "pinterest"], ["google", "google"], ["bing", "bing"], ["facebook", "facebook"],
  ["instagram", "instagram"], ["etsy", "etsy"], ["youtube", "youtube"], ["duckduckgo", "duckduckgo"]];

function sid() {
  let s = sessionStorage.getItem("dgh_sid");
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("dgh_sid", s); }
  return s;
}

export function attribution(): { source: string; campaign: string } {
  const saved = JSON.parse(localStorage.getItem("dgh_src") || "null");
  const q = new URLSearchParams(window.location.search);
  if (saved && !q.get("utm_source") && Date.now() - saved.ts < 30 * 864e5) return saved;
  let source = (q.get("utm_source") || "").toLowerCase();
  if (!source && document.referrer) {
    const host = new URL(document.referrer).hostname.replace(/^www\./, "");
    source = host === window.location.hostname.replace(/^www\./, "") ? "" : KNOWN.find(([k]) => host.includes(k))?.[1] || host;
  }
  const out = { source: (source || "direct").slice(0, 40), campaign: (q.get("utm_campaign") || "").slice(0, 80), ts: Date.now() };
  localStorage.setItem("dgh_src", JSON.stringify(out));
  return out;
}

export function track(type: "page_view" | "product_view", path: string, listing_id = "") {
  const a = attribution();
  api.post("/public/track", { type, path: path.slice(0, 300), sid: sid(), listing_id, source: a.source, campaign: a.campaign }).catch(() => {});
}

export function gaEvent(name: string, params: Record<string, unknown>) {
  window.gtag?.("event", name, params);
}

let gaLoaded = false;
export function loadGA() {
  if (gaLoaded || window.location.pathname.startsWith("/admin")) return;
  gaLoaded = true;
  api.get("/public/site-config").then(({ data }) => {
    if (!data.ga4_id) return;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${data.ga4_id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer!.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", data.ga4_id, { send_page_view: false });
    window.gtag("event", "page_view", { page_path: window.location.pathname });
  }).catch(() => {});
}
